import { Component, OnInit, Inject, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Observable, of } from 'rxjs';
import { BackgroundDashboardService } from '../../shared/services/backgroundDashboard.service';
import { Router } from '@angular/router';

@Component({
    selector: 'confirmation-add-service-dailog',
    templateUrl: './confirmationAddService.component.html',
})
export class ConfirmationAddServiceDialogComponent {
    public GetRedirectionState: string = "";

    constructor(public dialogRef: MatDialogRef<ConfirmationAddServiceDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any, public vcRef: ViewContainerRef, private BackgroundDashboardService: BackgroundDashboardService, private Router: Router) {
        this.GetRedirectionState = this.data.newObj;
        dialogRef.disableClose = true;


    }

    ngOnInit() {
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    ProceedToNextStep() {
        this.onNoClick()
        this.Router.navigate([this.GetRedirectionState])
    }

    RedirectToPaymentPage() {
        this.onNoClick();
        this.Router.navigate(['/background-login/payment'])
    }
}